import React, { useMemo } from 'react';

/**
 * 本月签到日历 - 纯展示，轻量
 * @param {{ monthSigned: number[], year: number, month: number }} props
 */
const CheckinCalendar = React.memo(({ monthSigned = [], year, month }) => {
    const signedSet = useMemo(() => new Set(monthSigned), [monthSigned]);
    const { days, firstWeekday } = useMemo(() => {
        const d = new Date(year, month - 1, 1);
        const first = d.getDay() || 7; // 周一=1 周日=7
        const lastDay = new Date(year, month, 0).getDate();
        const days = [];
        for (let i = 0; i < first - 1; i++) days.push(null);
        for (let i = 1; i <= lastDay; i++) days.push(i);
        return { days, firstWeekday: first };
    }, [year, month]);

    const weekdays = ['一', '二', '三', '四', '五', '六', '日'];
    const weekdayEmoji = ['🌱', '🌿', '🍃', '🌸', '🌺', '⭐', '🌈'];
    const monthLabel = `${year}年${month}月`;

    return (
        <div className="checkin-calendar">
            <div className="checkin-calendar-header">
                <span className="calendar-emoji">📆</span>
                <div className="checkin-calendar-title">{monthLabel}</div>
            </div>
            <div className="checkin-calendar-weekdays">
                {weekdays.map((w, idx) => (
                    <span key={w} className="weekday">
                        <span className="weekday-emoji">{weekdayEmoji[idx]}</span>
                        <span className="weekday-text">{w}</span>
                    </span>
                ))}
            </div>
            <div className="checkin-calendar-days">
                {days.map((d, i) => (
                    <div key={i} className={`day-cell ${d ? '' : 'empty'} ${d && signedSet.has(year * 10000 + month * 100 + d) ? 'signed-cell' : ''}`}>
                        {d ? (
                            <span className={signedSet.has(year * 10000 + month * 100 + d) ? 'signed' : 'day-num'}>
                                {d}
                            </span>
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    );
});

export default CheckinCalendar;
